import React, { useState, useEffect } from "react";
import { Card, CardContent, Box, Button } from "@material-ui/core";
import QuestionItem from "components/questionItem/QuestionItem";
import { collection, query, orderBy, onSnapshot } from "firebase/firestore";

import {
  firestore,
  convertQuestionsSnapshotToMap,
} from "firebase/firebase.utils";

// container
// List of questions
const QuestionsWithSelectedTopic = (props) => {
  const { selectedTopic, currentUser, analyzer } = props;
  const [questionsByTopic, setQuestionsByTopic] = useState([]);
  const [expandedQuestions, setExpandedQuestions] = useState({});

  const toggleExpanded = (questionId) => {
    console.log("Toggling question ID:", questionId);
    setExpandedQuestions((prev) => ({
      ...prev,
      [questionId]: !prev[questionId],
    }));
  };

  console.log(JSON.stringify(expandedQuestions));

  const collapseAll = () => {
    setExpandedQuestions({});
  };
  useEffect(() => {
    let unsubscribeQuestionsByTopicRef;
    // Reset expanded state when topic changes
    setExpandedQuestions({});
    if (Object.keys(selectedTopic).length > 0) {
      const questionsCollectionRef = collection(
        firestore,
        `questions-topics/${selectedTopic.topic}/questions`
      );
      const q = query(questionsCollectionRef, orderBy("score", "asc"));
      unsubscribeQuestionsByTopicRef = onSnapshot(q, async (querySnapshot) => {
        const convertedQuestionTopics = await convertQuestionsSnapshotToMap(
          querySnapshot
        );
        setQuestionsByTopic(convertedQuestionTopics);
      });
    }

    analyzer &&
      typeof analyzer.pageview === "function" &&
      analyzer.pageview(`TOPIC SELECTIONNE:${selectedTopic.topic}`);

    return () => {
      if (unsubscribeQuestionsByTopicRef) {
        unsubscribeQuestionsByTopicRef();
      }
    };
  }, [selectedTopic, analyzer]);

  const codeChallenges = questionsByTopic.filter((e) => e.isCodeChallenge);
  const noCodeChallenges = questionsByTopic.filter((e) => !e.isCodeChallenge);

  if (questionsByTopic) {
    return (
      <Card>
        <CardContent>
          <Box display="flex" justifyContent="flex-end" mb={2}>
            <Button variant="outlined" onClick={collapseAll}>
              Collapse All
            </Button>
          </Box>
          {questionsByTopic &&
            noCodeChallenges.map((question, index) => (
              <QuestionItem
                index={index}
                title={question.title}
                answer={question.answer}
                questionId={question.id}
                childId={question.questionDetailId}
                scoreDifficulty={question.score}
                key={question.id}
                topic={selectedTopic}
                currentUser={currentUser}
                analyzer={analyzer}
                expanded={expandedQuestions[question.id] || false}
                toggleExpanded={() => toggleExpanded(question.id)}
              />
            ))}
          <hr key="separator-hr" />
          <h3>Code challenges</h3>
          {codeChallenges &&
            codeChallenges.map((question, index) => (
              <QuestionItem
                index={index}
                title={question.title}
                answer={question.answer}
                questionId={question.questionId}
                childId={question.questionDetailId}
                scoreDifficulty={question.score}
                key={question.questionId}
                topic={selectedTopic}
                currentUser={currentUser}
                analyzer={analyzer}
                expanded={expandedQuestions[question.questionId] || false}
                toggleExpanded={() => toggleExpanded(question.questionId)}
              />
            ))}
        </CardContent>
      </Card>
    );
  }
  return null;
};

export default QuestionsWithSelectedTopic;
